// extracted by mini-css-extract-plugin
export default {"headerTable":"CasesPage_headerTable__WmlFj","subHeaderTable":"CasesPage_subHeaderTable__9zekp"};